import React from "react";
import Flash from "./Flash.jsx";
import Paginator from "./Paginator.jsx";
import Currency from "./currency.js";

class Customer extends React.Component {
  constructor(props){
    super(props);
    this.PAYMENT_LIMIT = 10;
    this.state = {
      customer: null,
      edited_customer: null,
      payment_methods: [],
      payments: [],
      payment_count: 0,
      payment_offset: 0,
      payment_limit: this.PAYMENT_LIMIT,
      edit_mode: false,
      saving: false,
      flash_messages: [],
      flash_timestamp: ""
    };

    this.retrieve_customer = this.retrieve_customer.bind(this);
    this.retrieve_payment_methods = this.retrieve_payment_methods.bind(this);
    this.retrieve_payments = this.retrieve_payments.bind(this);
    this.save_customer = this.save_customer.bind(this);
    this.start_editing = this.start_editing.bind(this);
    this.cancel_editing = this.cancel_editing.bind(this);
    this.update_field = this.update_field.bind(this);
  }

  componentDidMount(){
    this.retrieve_customer();
  }

  save_customer(){
    if (this.state.saving || !this.state.edited_customer){
      return;
    }

    const valid_fields = ['name','address','email','city','zip','country'];
    let body = {};
    valid_fields.forEach((field) => {
      body[field] = this.state.edited_customer[field];
    });

    this.setState({saving: true});
    fetch(`/customers/${this.props.id}`, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': this.props.auth_token
      },
      body: JSON.stringify({customer: body})
    }).then((response) => response.json()).then((json) => {
      if (!json.customer){
        const message = json.errors ? json.errors.join(', ') : (json.error || "Failed to update customer.");
        Flash.add_message(this, message, 'danger', 5);
        return this.setState({saving: false});
      }

      this.setState({
        customer: json.customer,
        edited_customer: null,
        edit_mode: false,
        saving: false
      });
      Flash.add_message(this, "Customer successfully updated.", 'success', 5);
    }).catch(() => {
      this.setState({saving: false});
      Flash.add_message(this, "Failed to update customer.", 'danger', 5);
    });
  }

  retrieve_customer(){
    fetch(`/customers/${this.props.id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json()).then((json) => {
      if (!json.customer){
        return Flash.add_message(this, "Error encountered in retrieving Customer.", 'danger', 5);
      }
      this.setState({customer: json.customer}, this.retrieve_payment_methods);
    }).catch(() => {
      Flash.add_message(this, "Error encountered in retrieving Customer.", 'danger', 5);
    });
  }

  retrieve_payment_methods(){
    fetch(`/payment_methods?q[customer_id_eq]=${this.props.id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json()).then((json) => {
      if (!json.payment_methods){
        return Flash.add_message(this, "Error encountered in retrieving Payment Methods.", 'danger', 5);
      }
      this.setState({payment_methods: json.payment_methods});
      this.retrieve_payments();
    }).catch(() => {
      Flash.add_message(this, "Error encountered in retrieving Payment Methods.", 'danger', 5);
    });
  }

  retrieve_payments(offset=this.state.payment_offset, limit=this.state.payment_limit){
    fetch(`/payments?q[customer_id_eq]=${this.props.id}&offset=${offset}&limit=${limit}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json()).then((json) => {
      if (!json.payments){
        return Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
      }
      this.setState({
        payments: json.payments,
        payment_count: json.count,
        payment_offset: offset,
        payment_limit: limit
      });
    }).catch(() => {
      Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
    });
  }

  start_editing(){
    this.setState({
      edited_customer: {...this.state.customer},
      edit_mode: true
    });
  }

  cancel_editing(){
    this.setState({edited_customer: null, edit_mode: false});
  }

  update_field(field, value){
    this.setState((state) => ({
      edited_customer: {...state.edited_customer, [field]: value}
    }));
  }

  display_value(value){
    return [null, undefined, ''].includes(value) ? '-' : value;
  }

  render_field(label, field){
    const customer = this.state.edit_mode ? this.state.edited_customer : this.state.customer;
    if (this.state.edit_mode){
      return (
        <div className="psintegril-form-group" key={field}>
          <label className="psintegril-label" htmlFor={`customer-${field}`}>{label}</label>
          <input
            id={`customer-${field}`}
            className="psintegril-input"
            type={field === 'email' ? 'email' : 'text'}
            value={customer[field] || ''}
            onChange={(event) => this.update_field(field, event.target.value)}
          />
        </div>
      );
    }

    return (
      <tr key={field}>
        <th>{label}</th>
        <td>{this.display_value(customer[field])}</td>
      </tr>
    );
  }

  render () {
    if (!this.state.customer){
      return null;
    }

    const editable_fields = [
      ['Name', 'name'],
      ['Email', 'email'],
      ['Address', 'address'],
      ['City', 'city'],
      ['ZIP / postal code', 'zip'],
      ['Country', 'country']
    ];

    return (
      <div className="psintegril-card">
        <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
        <div className="psintegril-card-header">
          <h1>{this.state.customer.name || 'Customer'}</h1>
        </div>

        {this.state.edit_mode ?
          <div>
            {editable_fields.map(([label, field]) => this.render_field(label, field))}
            <button className="psintegril-btn psintegril-btn-primary" type="button" onClick={this.save_customer} disabled={this.state.saving}>
              {this.state.saving ? 'Saving…' : 'Save'}
            </button>{' '}
            <button className="psintegril-btn psintegril-btn-secondary" type="button" onClick={this.cancel_editing} disabled={this.state.saving}>
              Cancel
            </button>
          </div>
        :
          <div>
            <div className="psintegril-table-container">
              <table className="psintegril-table">
                <tbody>
                  <tr><th>Created at</th><td>{this.display_value(this.state.customer.created_at)}</td></tr>
                  {editable_fields.map(([label, field]) => this.render_field(label, field))}
                  <tr><th>Stripe ID</th><td>{this.display_value(this.state.customer.id_gateway)}</td></tr>
                  <tr><th>Internal ID</th><td>{this.display_value(this.state.customer.id_internal)}</td></tr>
                  <tr><th>Status</th><td>{this.display_value(this.state.customer.status)}</td></tr>
                </tbody>
              </table>
            </div>
            <br />
            <button className="psintegril-btn psintegril-btn-secondary" type="button" onClick={this.start_editing}>Edit customer</button>
          </div>
        }

        <h2>Payment methods</h2>
        <div className="psintegril-table-container">
          <table className="psintegril-table">
            <tbody>
              <tr>
                <th>Name</th>
                <th>Payment type</th>
                <th>Status</th>
                <th>Expiry</th>
              </tr>
              {this.state.payment_methods.length > 0 ? this.state.payment_methods.map((payment_method) =>
                <tr key={payment_method.id}>
                  <td>{this.display_value(payment_method.name)}</td>
                  <td>{this.display_value(payment_method.payment_type)}</td>
                  <td>{this.display_value(payment_method.status)}</td>
                  <td>{payment_method.expiry_month && payment_method.expiry_year ? `${payment_method.expiry_month < 10 ? '0' : ''}${payment_method.expiry_month}/${payment_method.expiry_year % 2000}` : '-'}</td>
                </tr>
              ) :
                <tr><td colSpan="4">No payment methods found.</td></tr>
              }
            </tbody>
          </table>
        </div>

        <h2>Payments</h2>
        <div className="psintegril-table-container">
          <table className="psintegril-table">
            <tbody>
              <tr>
                <th>Date ({String(new Date()).slice(25,33)})</th>
                <th>ID</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Stripe ID</th>
              </tr>
              {this.state.payments.length > 0 ? this.state.payments.map((payment) =>
                <tr key={payment.id}>
                  <td>{payment.created_at ? String(new Date(payment.created_at)).slice(4,24) : '-'}</td>
                  <td><a href={`/s/payments/${payment.id}`}>{this.display_value(payment.id)}</a></td>
                  <td>
                    {payment.currency ? `${payment.currency.toUpperCase()} ${Currency.display(payment.amount, payment.currency)}` : this.display_value(payment.amount)}
                  </td>
                  <td>{this.display_value(payment.status)}</td>
                  <td>{this.display_value(payment.id_gateway)}</td>
                </tr>
              ) :
                <tr><td colSpan="5">No payments found.</td></tr>
              }
            </tbody>
          </table>
        </div>
        <Paginator
          on_page_change={(page) => {
            const offset = page * this.state.payment_limit;
            this.setState({payment_offset: offset}, () => this.retrieve_payments(offset, this.state.payment_limit));
          }}
          results={this.state.payment_count}
          per_page={this.state.payment_limit}
          page={Math.floor(this.state.payment_offset / this.state.payment_limit)}
        />
      </div>
    );
  }
}

export default Customer;
